import styled from 'styled-components';

export const StyledHeader = styled.div`
    display: flex;
    max-width: 416px;
    min-height: 84px;
    height: fit-content;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    padding: 40px 8px 0 8px;
    position: relative;
    z-index: 1;
    margin: 0 auto;
    box-sizing: border-box;
    visibility: ${(props: any) => props.visibility};
    font-family: ${(props: any) => props.fontFamily || 'inherit'};

    .logo {
        width: 128px;
        height: 80px;
        display: flex;
        justify-content: center;
        align-items: center;
        &.big {
            width: 152px;
            height: 104px;
        }
        img {
            height: 100%;
            width: 100%;
            object-fit: contain;
        }
    }

    .profileContainer {
        cursor: pointer;
        height: 44px;
        aspect-ratio: 1/1;

        .frame {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;
            aspect-ratio: 1/1;
            border-radius: 50%;
        }
        img {
            height: 90%;
            aspect-ratio: 1/1;
            border-radius: 50%;
        }
    }

    .bonus-badge {
        height: 44px;
        aspect-ratio: 1/1;
    }

    .logo-side {
        height: 44px;
        aspect-ratio: 1/1;

        img {
            height: 100%;
            object-fit: contain;
        }
    }

    .balance-container {
        flex: 1;
        padding: 0 1em;
        display: flex;
        align-items: center;
        flex-direction: row;
        gap: 0.5em;
        img {
            height: 24px;
            aspect-ratio: 1/1;
        }
        span {
            font-size: 1.25em;
            color: #ffffff;
        }
    }

    @media only screen and (min-width: 768px) {

        .profileContainer {
            height: 60px;
        }

        .logo {
            width: 180px;
            height: 100px;
            &.big {
                width: 176px;
                height: 128px;
            }
        }

        .logo-side {
            height: 60px;
        }
    }

    @media only screen and (min-width: 864px) {
        max-width: 864px;
    }

    @media only screen and (min-width: 1024px) {
        .logo {
            width: 196px;
            height: 120px;
            &.big {
                width: 220px;
                height: 160px;
            }
        }
    }

    @media only screen and (min-width: 1280px) {
        max-width: 1280px;
    }
` as any;
